// extracted by mini-css-extract-plugin
module.exports = {"timer-description":"style_timer-description__ispLo"};